import { allTrackers } from "app/services/track/track";
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";

export type ProjectCreationTrackingEntity = {
    trackSaveProjectCTAShow(): void;
    trackSaveProjectCTAHover(): void;
    trackSaveProjectCTAClick(): void;
    trackSaveProjectAlertsHover(): void;
    trackSaveProjectAlertsClick(): void;
    trackProjectCreationPopupOpen(numberOfDomains: number): void;
    trackEditDomainClick(): void;
    trackRemoveDomainClick(isPrimary: boolean): void;
    trackMakeNewPrimaryDomainClick(): void;
    trackWeeklyUpdatesToggle(isEnabled: boolean): void;
    trackProjectNameAlreadyExistsError(): void;
    trackCreateProjectSubmit(): void;
    trackClosePopup(): void;
    trackProjectCreationSuccessShow(): void;
    trackProjectCreationSuccessContinueHereClick(): void;
    trackProjectCreationSuccessGoToProjectsClick(): void;
    trackProjectCreationSystemErrorShow(): void;
    trackProjectCreationSystemErrorTryAgainClick(): void;
    trackProjectCreationSystemErrorContactSupportClick(): void;
    trackProjectCreationDuplicatedProjectErrorShow(): void;
    trackSaveProjectRedirectCTAClick(): void;
    trackAddNewDomainCTAClick(): void;
};

export const createProjectCreationTracking = (track: TrackType): ProjectCreationTrackingEntity => ({
    trackSaveProjectCTAShow() {
        track("Button", "show", "project from search");
    },
    trackSaveProjectCTAHover() {
        track("Button", "hover", "project from search");
    },
    trackSaveProjectCTAClick() {
        track("Button", "click", "project from search");
    },
    trackSaveProjectAlertsHover() {
        track("Button", "hover", "project from alert");
    },
    trackSaveProjectAlertsClick() {
        track("Button", "click", "project from alert");
    },
    trackProjectCreationPopupOpen(numberOfDomains) {
        track("popup", "open", `project from search/number of domains: ${numberOfDomains}`);
    },
    trackEditDomainClick() {
        track("popup", "click", "project from search/edit domain");
    },
    trackRemoveDomainClick(isPrimary) {
        track("popup", "click", `project from search/remove from list ${isPrimary ? "main domain" : ""}`);
    },
    trackMakeNewPrimaryDomainClick() {
        track("popup", "click", "project from search/make new primary domain");
    },
    trackWeeklyUpdatesToggle(isEnabled) {
        track("popup", "click", `project from search/send me weekly project updates/${isEnabled ? "on" : "off"}`);
    },
    trackProjectNameAlreadyExistsError() {
        track("popup", "error", "project from search/project name already in use");
    },
    trackCreateProjectSubmit() {
        track("popup", "submit", "project from search");
    },
    trackClosePopup() {
        track("popup", "close", "project from search");
    },
    trackProjectCreationSuccessShow() {
        track("popup", "show", "project from search/project created success");
    },
    trackProjectCreationSuccessContinueHereClick() {
        track("popup", "click", "project from search/project created success/continue here");
    },
    trackProjectCreationSuccessGoToProjectsClick() {
        track("popup", "click", "project from search/project created success/go to projects");
    },
    trackProjectCreationSystemErrorShow() {
        track("popup", "show", "project from search/project created error unsuccessful");
    },
    trackProjectCreationSystemErrorTryAgainClick() {
        track("popup", "click", "project from search/project created error unsuccessful/Try again");
    },
    trackProjectCreationSystemErrorContactSupportClick() {
        track("popup", "click", "project from search/project created error unsuccessful/Contact support");
    },
    trackProjectCreationDuplicatedProjectErrorShow() {
        track("popup", "show", "project from search/project created error duplicated project");
    },
    trackSaveProjectRedirectCTAClick() {
        track("internal link", "click", "save project/limit reached");
    },
    trackAddNewDomainCTAClick() {
        track("button", "click", "project from search/add domain");
    },
});

export default createProjectCreationTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
